// extracted by mini-css-extract-plugin
export var equalColumn = "_hh-0";